import React, { useState } from "react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaMap,
  FaShareAlt,
  FaHeart,
} from "react-icons/fa";

const PropertyDetailSidebar = ({
  property,
  propertyImages,
  onClose,
  onNext,
  onPrev,
  currentIndex,
  totalProperties,
}) => {
  const [activeImage, setActiveImage] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    property: "",
    message: "",
  });

  const images = [
    // propertyImages[property.id] ||
    "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=600&q=80",
    "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=600&q=80",
    "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&q=80",
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
  };

  return (
    <div className="w-full h-full bg-white p-4 overflow-y-auto">
      <div className="flex justify-between mb-4 flex-wrap">
        <button
          className="px-4 py-2 bg-orange-600 m-2 hover:bg-blue-900 cursor-pointer w-52 text-white rounded flex items-center justify-center gap-2"
          onClick={onPrev}
          disabled={currentIndex <= 0}
        >
          <FaChevronLeft /> Previous
        </button>
        <button
          className="px-4 py-2 bg-orange-600 m-2 hover:bg-blue-900 cursor-pointer w-52 text-white rounded flex items-center justify-center gap-2"
          onClick={onClose}
        >
          <FaMap /> View Map
        </button>
        <button
          className="px-4 py-2 bg-orange-600 m-2 hover:bg-blue-900 cursor-pointer w-52 text-white rounded flex items-center justify-center gap-2"
          onClick={onNext}
          disabled={currentIndex >= totalProperties - 1}
        >
          Next <FaChevronRight />
        </button>
      </div>

      <div className="flex flex-col md:flex-row gap-6 mb-6">
        <div className="mb-6 w-full md:w-2/3">
          <h2 className="text-lg font-bold mb-2">Detail & Features</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <div className="flex gap-2 items-center">
              <p className="text-xs text-gray-500">Bedrooms</p>
              <p className="font-medium">{property.bedrooms || "0"} Beds</p>
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-xs text-gray-500">Square</p>
              <p className="font-medium">
                {property.square_feet?.toLocaleString() || "0"} m²
              </p>
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-xs text-gray-500">Property type</p>
              <p className="font-medium">{property.home_type || "-"}</p>
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-xs text-gray-500">Status</p>
              <p className="font-medium">{property.cw_listing_status || "-"}</p>
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-xs text-gray-500">Floors</p>
              <p className="font-medium">{property.floors || "-"}</p>
            </div>
            <div className="flex gap-2 items-center">
              {/* Sub property type removed: property_type is deprecated */}
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-xs text-gray-500">Bathrooms</p>
              <p className="font-medium">{property.bathrooms || "0"} Bath</p>
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-xs text-gray-500">Category</p>
              <p className="font-medium">{property.category || "-"}</p>
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-xs text-gray-500">Garage space</p>
              <p className="font-medium">{property.garage_space || "-"}</p>
            </div>
          </div>

          <div className="w-full">
            <div className="relative h-64 w-full rounded-lg overflow-hidden mb-2">
              <img
                src={images[activeImage]}
                fill
                className="object-cover"
                alt={property.title || "Property image"}
                priority
              />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
              {images.map((img, index) => (
                <div
                  key={index}
                  className={`relative h-16 rounded cursor-pointer overflow-hidden ${activeImage === index ? "ring-2 ring-orange-500" : ""}`}
                  onClick={() => setActiveImage(index)}
                >
                  <img
                    src={img}
                    fill
                    className="object-cover"
                    alt={`Thumbnail ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/3">
          <div className="flex justify-between mb-6 flex-wrap gap-2">
            <button className="flex items-center gap-1 text-teal-500 border border-teal-500 bg-teal-100 px-4 py-2 rounded">
              <FaShareAlt /> Share
            </button>
            <button className="flex items-center gap-1 text-orange-500 border border-orange-500 bg-orange-100 px-4 py-2 rounded">
              <FaHeart /> Save
            </button>
          </div>

          <div className="bg-teal-500 p-4 text-white mb-6">
            <h3 className="text-lg font-bold mb-2">Contact Agent</h3>
            <p className="font-medium">3054006393</p>
          </div>

          <form className="space-y-3" onSubmit={handleSubmit}>
            <div>
              <input
                type="text"
                name="name"
                placeholder="Name *"
                className="w-full p-2 border border-gray-300 rounded"
                required
                value={formData.name}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <input
                type="tel"
                name="phone"
                placeholder="Phone *"
                className="w-full p-2 border border-gray-300 rounded"
                required
                value={formData.phone}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <input
                type="email"
                name="email"
                placeholder="Email *"
                className="w-full p-2 border border-gray-300 rounded"
                required
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <input
                type="text"
                name="property"
                placeholder="Property *"
                className="w-full p-2 border border-gray-300 rounded"
                required
                value={formData.property}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <textarea
                name="message"
                placeholder="Message *"
                className="w-full p-2 border border-gray-300 rounded"
                rows={3}
                required
                value={formData.message}
                onChange={handleInputChange}
              />
            </div>
            <button
              type="submit"
              className="w-full bg-orange-500 text-white py-2 px-4 rounded hover:bg-orange-600 transition-colors"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-b border-gray-200 py-4 mb-6">
        <h2 className="text-lg font-bold mb-2">Description</h2>
        <p className="text-gray-700">
          {property.description ||
            "Beautiful 1bed/1.5 bath apartment in the heart of Brickell with city views. UNIT IS FINISHED WITH PORCELAIN, FRESHLY PAINTED, CLOSETS AND WINDOW TREATMENT INSTALLED. Amenities include 24Hr concierge, valet, private lounge, resort style mezzanine with heated lap pool with cabanas, deluxe spa, fitness center, club room, kids room, theater, expansive 46th floor sky deck with pool and more."}
        </p>
      </div>
    </div>
  );
};

export default PropertyDetailSidebar;
